import React, { Component } from "react";
import axios from "axios";
import FilterCourse from "../filter_bar_course";
import Empty from "../../image/empty.svg"
import { Link } from "react-router-dom";
// import NumberDisplay from "../currencyValue";
// import { PiCurrencyNgn } from "react-icons/pi";
import Logo from "../../image/Logo.png"
import DateDisplay from "./dateformate";
// import { MdOutlineDeleteOutline } from "react-icons/md";


class UserSearchContent extends Component {
    state = {
        courses: [],
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
        Loading: false,
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchCourses(this.props.search);
    }
    componentDidUpdate(prevProps) { // Add componentDidUpdate
        if (prevProps.search !== this.props.search) { // Check if the search prop has changed
            this.fetchCourses(this.props.search); // Fetch courses with the new search term
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const search = this.props.search; // Assuming this contains the search term
        this.setState({ Loading: true })

        try {
            const params = new URLSearchParams(); // Use URLSearchParams to build query string
            if (search) {  // Only add the search param if it's not empty
                params.append('search', search);
            }

            const url = `https://api.geoinfoacademy.com/api/courses/?${params.toString()}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
        finally {
            this.setState({ Loading: false })
        }
    };


    handleRefresh = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: ""
        }, () => {
            // Important: Call the reset on the child!
            this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
        })
    }
    initialfilterbytype = () => {
        const courses = this.state.courses;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);
    
        }
    };
    
    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();
        
        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        }else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        }else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        } 
        
         else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);
    
        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        } 
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        } 
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };
    handleFilterChange = (filterType, filterLevel,filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };


    handlecoursetype = (field) => {
        if (field === "Online Prerecorded" || field === "Online Live" || field === "Online Live with Facilitator") {
            return "Online"
        } else {
            return "Physical"
        }
    }



    render() {
        const searchdata = this.initialfilterbystatus()
        // console.log("search course", this.initialfilterbylevel())
        function slugify(text) {
            return text
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric with -
              .replace(/^-+|-+$/g, '');   // trim dashes
          }

        const SearchCourses = searchdata.length > 0 ? searchdata.map((course) => {
            return (

                <section className="course_library" key={course.id}>
                    <Link to={`/description/${course.id}/${slugify(course.title)}`} >
                        <section className="image"><img src={course.thumbnail} alt="course_thumbnail" />
                        <div className="date_cover"><p><DateDisplay data={course.duration} /></p></div>
                        </section>
                        <section className="content">
                            <h3>
                                <span> {course.labels} : {course.tags}</span><br />
                                {course.title}
                            </h3>
                            <p className="details">{course.description}</p>
                            <p style={{color : this.handlecoursetype(course.training_type) === "Online" ? "rgb(1, 174, 95)" : "blue"}}>{course.training_type} 
                            {/* at <PiCurrencyNgn /> <NumberDisplay value={course.price}/> */}
                            </p>
                        </section>
                    </Link>
                </section>

            )
        }) : (
            <div className="course_list_empty">
                <img src={Empty} alt="not avaialable" /><br />
                <h5>No Available Course <br />with that specification.</h5>
                <button onClick={this.handleRefresh}>Reset Filter</button>
            </div>
        )

        return (
            <div >
                <div className="course_head">
                    <h2> Search </h2>
                    <FilterCourse
                        filterType={this.state.filter_type_name} // Pass current values as props
                        filterLevel={this.state.filter_level_name}
                        filterStatus={this.state.filter_status_name}
                        onFilterChange={this.handleFilterChange}
                        ref={(el) => this.filterRef = el}
                    />
                </div>
                <div className="search_content">
                {this.state.Loading === true ?
                        <div className="loading_error">
                        <div className="cover">
                            <section className="image">
                                <img src={Logo} alt="not avaialable" /><br />
                            </section>
                        </div>
                    </div>
                        :
                        SearchCourses 
                    }
                </div>
            </div>
        )
    }
}


export default UserSearchContent